import { configureStore } from '@reduxjs/toolkit';
import loaderReducer from './reducers/LoaderReducer';
import copyLeagueReducer from './reducers/CopyLeagueReducer';
import permissionsReducer from './reducers/PermissionsReducer';
import ContactUsReducer from './reducers/ContactUsReducer';
import OverviewFilters from './reducers/OverviewFilters';

export const store = configureStore({
  reducer: {
    loader: loaderReducer,
    copyLeague: copyLeagueReducer,
    permissions: permissionsReducer,
    contactUsCount: ContactUsReducer,
    overviewFilters: OverviewFilters,
  },
});